import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Caret(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path d="M24 15l-6 8-6-8z"></path>
    </IconSvg>
  );
}
